import parse from './parse';
import check from './check';

export default { parse, check };
